import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { isSettingsRoute } from 'src/app/modules/settings/settings-menu.data';

@Injectable({
  providedIn: 'root'
})
export class TopbarService {

  private defaultWindowTitle:string = "GUAi - Gestor de Operaciones";
  private title:string = "";
  private breadcrumb:any[] = [];

  /// Si `getBreadcrumb` añade al final un tramo con el título de la pantalla. Ver `setBreadcrumb`.
  private appendTitleToBreadcrumb:boolean = true;
  private actions:any[] = [];
  private count:number | null = null;
  private subtitle:string = "";

  constructor(
    private router: Router,
    private titleService: Title
  ) {
    router.events.subscribe((val) => {
      if(val instanceof NavigationEnd){
        this.breadcrumb = [];
        this.appendTitleToBreadcrumb = true;
        this.actions = [];
        this.title = "";
        this.count = null;
        this.subtitle = "";
        this.titleService.setTitle(this.defaultWindowTitle);
        if(isSettingsRoute(val.urlAfterRedirects)){
          this.breadcrumb.push({label: 'Configuración', url: '/settings'});
        }
      }
    });

  }

  setWindowTitle(title: string) {
    //this.titleService.setTitle("GUAi - " + title);
    if(title=='') title = "GUAi";
    this.titleService.setTitle(title);
  }

  setTitle(title: string) {
    this.title = title;
  }

  setCount(count: number | null | undefined) {
    this.count = typeof count == 'number' ? count : null;
  }

  getCount() {
    return this.count;
  }

  setSubtitle(subtitle: string) {
    this.subtitle = subtitle;
  }

  getSubtitle() {
    return this.subtitle;
  }

  getTitle() {
    return this.title;
  }

  addBreadcrumb(label: string, url: string) {
    this.breadcrumb.push({label: label, url: url});
  }

  /// Reemplaza la ruta de navegación completa.
  ///
  /// Hace falta para las pantallas que la construyen con datos que llegan después (un nombre que se carga por
  /// petición) y que además cambian de ruta sin recrearse: ahí `addBreadcrumb` duplicaría entradas, porque la
  /// lista solo se vacía al terminar una navegación.
  /// @param appendTitle si al final se añade un tramo con el título de la pantalla apuntando a la ruta actual.
  /// Ponerlo a false es para las pantallas cuyo último tramo no debe apuntar donde estás: en el buzón, el último
  /// tramo es la carpeta, y con un mensaje abierto la ruta actual es el mensaje, así que ese enlace no llevaría a
  /// la carpeta sino al correo que ya tienes delante.
  setBreadcrumb(items: {label: string, url: string}[], appendTitle: boolean = true) {
    this.breadcrumb = [ ...items ];
    this.appendTitleToBreadcrumb = appendTitle;
  }

  clearBreadcrumb() {
    this.breadcrumb = [];
    this.appendTitleToBreadcrumb = true;
  }

  getBreadcrumb() {
    let items = [ ...this.breadcrumb ];
    if(this.appendTitleToBreadcrumb) items.push({label: this.title, url: location.pathname});
    return items;
  }

  addAction(label: string, icon: string, show_text:boolean = false, action: Function, menuItems?: MenuItem[]) {    
    this.actions.push({label: label, icon: icon, show_text: show_text, action: action, menuItems:       
      menuItems
    });
  }

  getActions() {
    return this.actions;
  }

  doAction(action:any){
    action.action();
  }  

  getMenuItems(action: any) {        
    return action.menuItems;
  }

}
